import { useEffect, useState } from 'react'
import { getUserScheme } from '../api'
import { getProjectByKey, goToLink, loginLogout, SchemeCard } from '../projectData'
import { useNavigate } from 'react-router-dom'
import { FullPageLoader } from '../../component/helper'
import { useRouteData } from '../RouteDataContext'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

/**
 * SchemeDashboard component displays a list of running schemes for the user.
 * Handles scheme selection, navigation, and loading state.
 */
const SchemeDashboard = () => {

    const navigate = useNavigate()
    const [loader, setLoader] = useState(false);
    const [schemeData, setSchemeData] = useState([])
    const { userData } = useRouteData();
    useEffect(() => {
        //   localStorage.removeItem("pkey")
        // localStorage.removeItem("company")
        setLoader(true)
        getUserScheme().then((data) => {
            setLoader(false)
            setSchemeData(data.data)
        }).catch((error) => {
            loginLogout(error.response)
            setLoader(false)
        })
    }, [])


    const handleClick = (project) => {
        setLoader(true);
        localStorage.setItem("pkey", project?.pkey)
        localStorage.setItem("company", project?.pname)
        setTimeout(() => {
            setLoader(false);
            navigate('/customer/dashboard');
        }, 500);
    }

    return (
        <div className='container vh-100' >
            <div className="card p-2 my-4 border rounded" style={{ backgroundColor: "#FBF6F7", border: "1px solid #FBF6F7" }}>
                <div className="card-body p-2" >
                    <div className='fw-semibold fs-4' > Here is a list of running schemes.</div>
                </div>
            </div>
            <div className="row  mb-4">
                <div className="col-lg-8">
                    <div
                        className="card shadow-sm border-0 mb-3 kyc-card-hover"
                        style={{
                            background: "linear-gradient(90deg, #232526 0%, #414345 100%)",
                            cursor: "pointer",
                            transition: "box-shadow 0.2s",
                        }}
                        onClick={() => navigate(`/customer/bankpancard-details/${userData?.user?.iirpl_sap_code}`)}
                    >
                        <div className="card-body d-flex align-items-center justify-content-between py-5 px-5">
                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center justify-content-center me-4" style={{ width: 64, height: 64 }}>
                                    <img src={toAbsoluteUrl('/media/images/kyc@2x.png')} alt="KYC" />
                                </div>
                                <div>
                                    <div className="fw-semibold text-white fs-4 mb-1">KYC Verification</div>
                                    <div className="text-gray-400 fs-6">Upload your PAN and Bank details to complete your KYC.</div>
                                </div>
                            </div>
                            <div className="symbol symbol-25px symbol-circle">
                                <span className="symbol-label fs-6 fw-semibold text-white" style={{ backgroundColor: "#fff" }}>
                                    <i className="fas fa-chevron-right text-dark"></i>
                                </span>
                            </div>
                            {/* <div className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: "#fff",
                                }}>
                                <i className="fas fa-chevron-right text-dark fs-5"></i>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" >

                {schemeData.length > 0 ? (
                    schemeData.map((scheme) => {
                        const project = getProjectByKey(scheme?.ref_key); // Assuming `project_key` is a property of `scheme`
                        if (project?.pname === 'mitr') { goToLink(navigate, '/customer/dashboard', []); }
                        return (
                            <div className='col-md-6 p-3' key={scheme.id} onClick={() => handleClick(project)}>
                                <SchemeCard project={project} />
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center text-danger mt-4 fw-semibold fs-4">
                        No schemes assigned.
                    </div>
                )
                }
            </div>
            {loader &&
                <FullPageLoader />
            }
        </div>
    )
}


export default SchemeDashboard